import React, { useEffect, useState } from "react";

export const VESTA_LAUNCH_AT = new Date("2026-10-23T10:00:00+02:00").getTime();
export const isVestaLaunched = () => Date.now() >= VESTA_LAUNCH_AT;
export const vestaVisible = (link) => !link.vesta || isVestaLaunched();

export const withAi = (str) => str.split("Ai").flatMap((part, i) => (i ? [<React.Fragment key={i}>A<span className="normal-case">i</span></React.Fragment>, part] : [part]));

export function useVestaLaunched() {
  const [launched, setLaunched] = useState(isVestaLaunched);
  useEffect(() => {
    if (launched) return undefined;
    const id = setTimeout(() => setLaunched(true), Math.min(VESTA_LAUNCH_AT - Date.now() + 500, 2 ** 31 - 1));
    return () => clearTimeout(id);
  }, [launched]);
  return launched;
}
